"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _ProductImagePreview = _interopRequireDefault(require("../ProductImagePreview/ProductImagePreview"));

var _SenderGiftLanguage = _interopRequireDefault(require("../../containers/SenderGiftLanguage/SenderGiftLanguage"));

var _ProductPriceInput = _interopRequireDefault(require("../ProductPriceInput/ProductPriceInput"));

var _features = require("../../../Shared/store/features");

var _ProductPriceDropdown = _interopRequireDefault(require("../ProductPriceDropdown/ProductPriceDropdown"));

/* eslint-disable react/no-danger */
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    brandImage: function brandImage(props) {
      return {
        minWidth: '97px',
        height: '97px',
        background: "url(".concat(props.image, ") center center / contain no-repeat")
      };
    },
    icon: {
      marginRight: theme.spacing(1)
    }
  };
});

var ProductPreview = function ProductPreview(_ref) {
  var onClose = _ref.onClose,
      isLoading = _ref.isLoading,
      product = _ref.product,
      disabled = _ref.disabled,
      onChoose = _ref.onChoose;
  var classes = useStyles({
    image: product ? product.brand.image : null
  });
  var multipleValues = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.MULTIPLE_GIFT_CARD_VALUES));
  return !isLoading && product ? /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Body-Regular-Center-Link-Bold Text-Pointer",
    onClick: onClose,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    className: classes.icon,
    color: "inherit",
    icon: "arrow-left"
  }), " Go back"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2,
    p: 3,
    bgcolor: "common.white",
    borderRadius: "5px"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "H4-Chambray"
  }, product.name), !product.hasExternalFulfillment && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Body-Small-Inactive"
  }, "from ", product.brand.name), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_ProductImagePreview.default, {
    images: product.images
  })), multipleValues && product.hasRangeDenomination && /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    pb: 2
  }, product.giftCardRange.denominations && product.giftCardRange.denominations.length > 0 ? /*#__PURE__*/_react.default.createElement(_ProductPriceDropdown.default, {
    product: product
  }) : /*#__PURE__*/_react.default.createElement(_ProductPriceInput.default, {
    product: product
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    pb: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    fullWidth: true,
    variant: "contained",
    color: "secondary",
    disabled: disabled,
    onClick: onChoose
  }, /*#__PURE__*/_react.default.createElement("span", null, "Choose ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null)))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Label-Table-Left-Active"
  }, "PRODUCT DETAILS"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Body-Regular-Left-Static"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: product.description
    }
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 3,
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Body-Regular-Left-Static-Bold"
  }, "About ", product.brand.name), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    pt: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.brandImage
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pl: 2,
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Body-Small-Static"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: product.brand.description
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Body-Small-Static",
    pt: 2
  }, "Visit us at", ' ', /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "http://".concat(product.brand.website)
  }, product.brand.website)))))) : /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": "CreateGift-ProductPreviewLoader",
    key: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    m: 4
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null));
};

ProductPreview.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  product: _propTypes.default.object,
  onClose: _propTypes.default.func.isRequired,
  onChoose: _propTypes.default.func.isRequired,
  isLoading: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool.isRequired
};
ProductPreview.defaultProps = {
  product: null
};
var _default = ProductPreview;
exports.default = _default;